module.exports = __webpack_public_path__ + "static/img/Matt-Whitlock.820069c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matt-Whitlock.jpg
// module id = ZR9o
// module chunks = 0